<template>
	<div class="followButton">
		<single-button :text="button.text" :color="button.color" width="3rem" height="1.5rem" fontSize="0.7rem"
			radius="1rem" :border="button.border" :background="button.background" @know="toLike" class="btn">
		</single-button>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	name: 'FollowButton',
	props: {
		item: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			follow: false,
			state: this.type,
			button: {
				text: "关注TA",
				color: "#FFFFFF",
				background: "#8E703A",
				border: "",
			},
		}
	},
	watch: {
		item: {
			handler(val) {
				this.state = val.status;
				this.buttonType();
			},
			immediate: true,
		},
	},
	methods: {
		...mapActions(["getUserInfo"]),
		toLike() {
			if (this.item.status == 1) {
				this.$ajax('/user/cancelFollowGame', {
					game_id: this.item.game_id
				}).then(rs => {
					if (rs.code == 200) {
						this.item.status = 0;
						this.state = this.item.status;
						this.buttonType();
						this.$toast(rs.msg);
						this.getUserInfo();
					} else {
						this.$toast(rs.msg);
					}
				})
			} else if (this.item.status == 0) {
				this.$ajax('/user/followGame', {
					game_id: this.item.game_id
				}).then(rs => {
					if (rs.code == 200) {
						this.item.status = 1;
						this.state = this.item.status;
						this.buttonType();
						this.getUserInfo();
						this.$toast(rs.msg);
					} else {
						this.$toast(rs.msg);
					}
				})
			}
		},
		buttonType() {
			let button = {};
			switch (this.state) {
				case 0:
					button = {
						text: "+关注",
						color: "#FFDB89",
						background: "linear-gradient( 87deg, #1D1D1D 0%, #5B4E3F 100%)",
						border: "",
					};
					break;
				case 1:
					button = {
						text: "已关注",
						color: "#fff",
						background: " #8E8E8E",
					};
					break;
			}
			this.button = button;
		},
	},
}
</script>

<style lang="scss" scoped>
.btn {
	text-align: center !important;
	line-height: 1.125rem !important;
}
</style>